import byteToMiB from '@app/libs/byteToMiB';

import { UPLOAD_FILE_BYTE } from '../../constants';
import FileSelectErrorCode from '../../types/FileSelectErrorCode';

export default function getPDFSelectorErrorMessage(error: FileSelectErrorCode) {
  return errorMessageMap[error];
}

const errorMessageMap: Record<FileSelectErrorCode, string> = {
  'file-invalid-type':
    '선택한 문서가 지원하지 않는 파일 형식입니다.\nPDF 파일이 맞는지 확인해 주세요.',
  'file-too-large': `선택한 문서가 최대 용량(${byteToMiB(
    UPLOAD_FILE_BYTE
  )}MB)을 초과합니다.\n파일의 용량을 확인해 주세요.`,
  'too-many-files': '1개의 문서만 선택해 주세요.',
};
